import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavItem } from 'reactstrap';
import { Link, Events, scrollSpy, animateScroll } from 'react-scroll';

class DayPlanMealLink extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        mealId: PropTypes.number.isRequired,
        triggerOpenMeal: PropTypes.func.isRequired,
    };

    componentDidMount() {
        Events.scrollEvent.register('begin', to => {
            if (to) {
                this.props.triggerOpenMeal(to);
                animateScroll.scrollMore(1);
            }
        });

        // hack to hide timeline
        Events.scrollEvent.register('end', to => {
            if (to) {
                animateScroll.scrollMore(1);
            }
        });

        scrollSpy.update();
    }

    componentWillUnmount() {
        Events.scrollEvent.remove('begin');
        Events.scrollEvent.remove('end');
    }

    render() {
        return (
            <NavItem>
                <Link
                    className="nav-link"
                    activeClass="active"
                    to={`meal${this.props.mealId}`}
                    spy
                    smooth
                    offset={-40}
                >
                    {this.props.name}
                </Link>
            </NavItem>
        );
    }
}

export default DayPlanMealLink;
